// 异常信息
export const FORM_EXCEPTION_INFORMATION = ['出错堆栈', 'Issue 类型', '卡顿耗时（毫秒）', '监控粒度', '异常名称', 'Issue ID', '消息ID',
  '用户ID', '设备ID', '系统版本', '机型', '厂商', '运行时架构', 'CPU', 'CPU架构', 'ROM', '前后台状态', '使用时长', '可用内存', '出错线程', '出错进程',
  '场景', '自定义字段', '自定义维度', '实验ID', '业务下钻', '个例标签',
];


